<template>
  <div>
    <template v-if="header.id === 'checkbox'">
      <vchecklabel
        :disabled="isLastAdmin || isUserAdmin"
        v-model="isSelected"/>
    </template>

    <template v-else-if="header.id === 'vacancy'">
      <div class="name-block">
        {{ full_name }}
      </div>
    </template>

    <template v-else-if="header.id === 'rights'">
      <multiselect
        v-if="allowManage"
        v-model="userPermission"
        open-direction="bottom"
        :options="userPermissions"
        :show-labels="false"
        :allow-empty="false"
        :searchable="false"
        track-by="id"
        label="name"
        :disabled="isLastAdmin || isUserAdmin"
        class="big bottom"
      />
      <div v-else>{{ userPermission.name }}</div>
    </template>

    <template v-else-if="header.id === 'email'">
      <div>{{ user.email }}</div>
    </template>

    <template v-else-if="header.id === 'phone'">
      <div>{{ user.phone }}</div>
    </template>

    <template v-else-if="header.id === 'region'">
      <div>{{ user.geo ? user.geo.description : '' }}</div>
    </template>
  </div>
</template>

<script>
  import { find } from 'lodash'

  export default {
    name: 'preferences-accesses-row',

    props: {
      model: Object,
      list: Array,
      permissions: Array,
      allowManage: Boolean,
      vacancy: Object,
      header: Object,
      cell: Object,
    },

    components: {},

    methods: {
      updateModel (data) {
        const {id} = data.permission
        const {email} = this.model

        this.$store.commit('vacancy/updatePermission', {id, user: {email}})
      },

      checkLastAdmin () {
        if (this.model && this.model.permission === 'admin') {
          this.isSelected = false
        }
      }
    },

    computed: {
      user () {
        return this.model
      },

      currentUser () {
        return this.$store.getters['user/current']
      },

      isUserAdmin () {
        if (!this.vacancy || !this.model || !this.currentUser) {
          return false
        }

        if (this.vacancy.role === 'admin') {
          return this.model.email === this.currentUser.email
        } else {
          return false
        }
      },

      isLastAdmin () {
        return this.model ? this.model.isLastAdmin : false
      },

      userPermissions () {
        if (!this.permissions) {
          return []
        }

        if (this.vacancy && this.vacancy.role !== 'admin') {
          return this.permissions.filter(permission => permission.id !== 'admin')
        } else {
          return this.permissions
        }
      },

      userPermission: {
        get () {
          return find(this.permissions, {id: this.model.permission}) || {}
        },

        set (val) {
          this.updateModel({
            permission: val
          })
        }
      },

      isSelected: {
        get () {
          return this.$store.getters['users/isSelected'](this.model)
        },

        set (state) {
          if (state && this.model.permission === 'admin') {
            const adminUsers = this.list ? this.list.filter(item => item.permission === 'admin') : []
            const selectedAdminUsers = this.$store.getters['users/selectedUsers'] ? [...this.$store.getters['users/selectedUsers'].filter(item => item.permission === 'admin'), this.model] : []

            if (selectedAdminUsers.length >= adminUsers.length) {
              this.isSelected = false
              return
            }
          }

          this.$store.dispatch('users/setSelectedState', {model: this.model, state})
        }
      },

      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      },

      full_name() {
        return !this.is_japan_locale ? [this.user.name, this.user.surname].join(' ') : [this.user.surname, this.user.name].join(' ');
      }

    },

    beforeMount () {
      this.checkLastAdmin()
    }
  }
</script>

<style lang="scss" scoped>
  td {
    padding: 4px 5px;
    word-break: break-word;

    ::v-deep {
      .multiselect.big {
        width: 160px;
      }
    }
  }

  .column-checkbox {
    padding-left: 0;
  }

  .name-block {
    display: flex;
    align-items: center;
  }

  .avatar-block {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>
